<template>
  <section
    class="bg-white py-5 lg:py-5 heebo_text overflow-hidden relative z-10"
  >
    <div class="container">
      <div class="row">
        <div
          class="col-lg-6 col-xl-6 aos-init"
          data-aos="fade-right"
          data-aos-once="false"
          data-aos-duration="1500"
        >
          <div class="mb-12" style="max-width: 570px">
            <h2 class="contact-title">
              {{ $t("contact_us_now") }}
            </h2>
            <p class="contact-sub-title fs-4">
              {{ $t("contact_info") }}
            </p>
            <div class="d-flex flex-wrap" style="max-width: 370px">
              <div
                class="me-3 flex h-60 w-60 max-w-60 pe-2 justify-content-center overflow-hidden rounded text-primary"
              >
                <svg
                  width="30"
                  height="50"
                  viewBox="0 0 24 24"
                  class="fill-current"
                >
                  <path
                    d="M21.8182 24H16.5584C15.3896 24 14.4156 23.0256 14.4156 21.8563V17.5688C14.4156 17.1401 14.0649 16.7893 13.6364 16.7893H10.4026C9.97403 16.7893 9.62338 17.1401 9.62338 17.5688V21.8173C9.62338 22.9866 8.64935 23.961 7.48052 23.961H2.14286C0.974026 23.961 0 22.9866 0 21.8173V8.21437C0 7.62972 0.311688 7.08404 0.818182 6.77223L11.1039 0.263094C11.6494 -0.0876979 12.3896 -0.0876979 12.9351 0.263094L23.2208 6.77223C23.7273 7.08404 24 7.62972 24 8.21437V21.7783C24 23.0256 23.026 24 21.8182 24ZM10.3636 15.4251H13.5974C14.7662 15.4251 15.7403 16.3995 15.7403 17.5688V21.8173C15.7403 22.246 16.0909 22.5968 16.5195 22.5968H21.8182C22.2468 22.5968 22.5974 22.246 22.5974 21.8173V8.25335C22.5974 8.13642 22.5195 8.01949 22.4416 7.94153L12.1948 1.4324C12.0779 1.35445 11.9221 1.35445 11.8442 1.4324L1.55844 7.94153C1.44156 8.01949 1.4026 8.13642 1.4026 8.25335V21.8563C1.4026 22.285 1.75325 22.6358 2.18182 22.6358H7.48052C7.90909 22.6358 8.25974 22.285 8.25974 21.8563V17.5688C8.22078 16.3995 9.19481 15.4251 10.3636 15.4251Z"
                  />
                </svg>
              </div>
              <div class="flex-grow-1">
                <h3 class="mb-0 contact-title-2 bold">
                  {{ $t("our_location") }}
                </h3>
                <p class="contact-desc bold">
                  {{ $t("location_salamis") }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-wrap" style="max-width: 370px">
              <div
                class="me-3 flex h-60 w-60 pe-2 max-w-60 justify-content-center overflow-hidden rounded text-primary"
              >
                <svg
                  width="30"
                  height="50"
                  viewBox="0 0 24 26"
                  class="fill-current"
                >
                  <path
                    d="M22.6149 15.1386C22.5307 14.1704 21.7308 13.4968 20.7626 13.4968H2.82869C1.86042 13.4968 1.10265 14.2125 0.97636 15.1386L0.092295 23.9793C0.0501967 24.4845 0.21859 25.0317 0.555377 25.4106C0.892163 25.7895 1.39734 26 1.94462 26H21.6887C22.1939 26 22.6991 25.7895 23.078 25.4106C23.4148 25.0317 23.5832 24.5266 23.5411 23.9793L22.6149 15.1386ZM21.9413 24.4424C21.8992 24.4845 21.815 24.5687 21.6466 24.5687H1.94462C1.81833 24.5687 1.69203 24.4845 1.64993 24.4424C1.60783 24.4003 1.52364 24.3161 1.56574 24.1477L2.4498 15.2649C2.4498 15.0544 2.61819 14.9281 2.82869 14.9281H20.8047C21.0152 14.9281 21.1415 15.0544 21.1835 15.2649L22.0676 24.1477C22.0255 24.274 21.9834 24.4003 21.9413 24.4424Z"
                  />
                  <path
                    d="M11.7965 16.7805C10.1547 16.7805 8.84961 18.0855 8.84961 19.7273C8.84961 21.3692 10.1547 22.6742 11.7965 22.6742C13.4383 22.6742 14.7434 21.3692 14.7434 19.7273C14.7434 18.0855 13.4383 16.7805 11.7965 16.7805ZM11.7965 21.2008C10.9966 21.2008 10.3231 20.5272 10.3231 19.7273C10.3231 18.9275 10.9966 18.2539 11.7965 18.2539C12.5964 18.2539 13.2699 18.9275 13.2699 19.7273C13.2699 20.5272 12.5964 21.2008 11.7965 21.2008Z"
                  />
                  <path
                    d="M1.10265 7.85562C1.18684 9.70794 2.82868 10.4657 3.67064 10.4657H6.61752C6.65962 10.4657 6.65962 10.4657 6.65962 10.4657C7.92257 10.3815 9.18552 9.53955 9.18552 7.85562V6.84526C10.5748 6.84526 13.7742 6.84526 15.1635 6.84526V7.85562C15.1635 9.53955 16.4264 10.3815 17.6894 10.4657H17.7315H20.6363C21.4782 10.4657 23.1201 9.70794 23.2043 7.85562C23.2043 7.72932 23.2043 7.26624 23.2043 6.84526C23.2043 6.50847 23.2043 6.21378 23.2043 6.17169C23.2043 6.12959 23.2043 6.08749 23.2043 6.08749C23.078 4.90874 22.657 3.94047 21.9413 3.18271L21.8992 3.14061C20.8468 2.17235 19.5838 1.62507 18.6155 1.28828C15.795 0.193726 12.2587 0.193726 12.0903 0.193726C9.6065 0.235824 8.00677 0.446315 5.60716 1.28828C4.681 1.58297 3.41805 2.13025 2.36559 3.09851L2.3235 3.14061C1.60782 3.89838 1.18684 4.86664 1.06055 6.04539C1.06055 6.08749 1.06055 6.12959 1.06055 6.12959C1.06055 6.21378 1.06055 6.46637 1.06055 6.80316C1.10265 7.18204 1.10265 7.68722 1.10265 7.85562ZM3.37595 4.15097C4.21792 3.3932 5.27038 2.93012 6.15444 2.59333C8.34355 1.79346 9.7749 1.62507 12.1745 1.58297C12.3429 1.58297 15.6266 1.62507 18.1525 2.59333C19.0365 2.93012 20.089 3.3511 20.931 4.15097C21.394 4.65615 21.6887 5.32972 21.7729 6.12959C21.7729 6.25588 21.7729 6.46637 21.7729 6.80316C21.7729 7.22414 21.7729 7.68722 21.7729 7.81352C21.7308 8.78178 20.8047 8.99227 20.6784 8.99227H17.7736C17.3526 8.95017 16.679 8.78178 16.679 7.85562V6.12959C16.679 5.7928 16.4685 5.54021 16.1738 5.41392C15.9213 5.32972 8.55405 5.32972 8.30146 5.41392C8.00677 5.49811 7.79628 5.7928 7.79628 6.12959V7.85562C7.79628 8.78178 7.1227 8.95017 6.70172 8.99227H3.79694C3.67064 8.99227 2.74448 8.78178 2.70238 7.81352C2.70238 7.68722 2.70238 7.22414 2.70238 6.80316C2.70238 6.46637 2.70238 6.29798 2.70238 6.17169C2.61818 5.32972 2.91287 4.65615 3.37595 4.15097Z"
                  />
                </svg>
              </div>
              <div class="flex-grow-1">
                <h3 class="mb-0 contact-title-2 bold">
                  {{ $t("phone_number") }}
                </h3>
                <div class="cf-phone-list">
                  <!-- +392 KKTC -->
                  <div class="cf-phone-row">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"/></svg>
                    <a href="tel:+903926330000" class="cf-phone-link">+90 392 633 00 00</a>
                  </div>
                  <!-- +90 850 Free International -->
                  <div class="cf-phone-row">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"/></svg>
                    <a href="tel:+908507070101" class="cf-phone-link">+90 850 707 01 01</a>
                    <span class="cf-phone-tag">{{ $t('phone_free_international') }}</span>
                  </div>
                  <!-- 0850 Free KKTC -->
                  <div class="cf-phone-row">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"/></svg>
                    <a href="tel:08507070101" class="cf-phone-link">0850 707 01 01</a>
                    <span class="cf-phone-tag">{{ $t('phone_free_kktc') }}</span>
                  </div>
                  <!-- WhatsApp only -->
                  <div class="cf-phone-row">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50" fill="currentColor"><path d="M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 29.079097 3.1186875 32.88588 4.984375 36.208984 L 2.0371094 46.730469 A 1.0001 1.0001 0 0 0 3.2402344 47.970703 L 14.210938 45.251953 C 17.434629 46.972929 21.092591 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 21.278025 46 17.792121 45.029635 14.761719 43.333984 A 1.0001 1.0001 0 0 0 14.033203 43.236328 L 4.4257812 45.617188 L 7.0019531 36.425781 A 1.0001 1.0001 0 0 0 6.9023438 35.646484 C 5.0606869 32.523592 4 28.890107 4 25 C 4 13.390466 13.390466 4 25 4 z M 16.642578 13 C 16.001539 13 15.086045 13.23849 14.333984 14.048828 C 13.882268 14.535548 12 16.369511 12 19.59375 C 12 22.955271 14.331391 25.855848 14.613281 26.228516 L 14.615234 26.230469 C 14.973031 26.752191 15.486328 27.419922 15.999626 28.087653 C 16.717405 28.96464 17.619141 29.914062 19.422612 31.812909 C 21.958282 34.007419 25.105469 35.349609 26.554789 35.966779 C 27.698179 36.339417 28.564453 36.611328 30.169845 37.115426 C 31.632073 37.038799 32.730469 36.876953 33.55263 36.755876 C 34.456878 36.361114 35.351562 35.794922 36.246248 35.22873 C 37.12309 34.524722 37.509766 33.455078 37.786772 32.688244 C 37.927591 31.979598 37.978516 31.396484 37.988281 30.609375 C 37.969311 30.371148 37.767578 29.824219 37.302009 29.059804 C 36.774753 29.039853 36.224609 28.767578 35.337891 30.558594 C 35.748225 30.761674 35.942113 30.893881 35.992188 30.894531 C 35.998992 31.07786 35.986328 31.222656 35.951258 31.624292 C 35.8439 32.180225 35.628906 32.775391 35.523582 33.066746 C 34.975018 33.667661 34.283203 34.105469 33.591388 34.543277 C 32.749338 34.852514 32.4375 34.898438 31.499896 35.036591 C 30.386672 35.087027 29.164062 34.703125 28.316336 34.437036 C 27.259305 34.092596 25.890625 33.509766 23.114812 32.325956 C 20.755591 30.311513 19.070312 28.537109 18.227674 27.649908 C 17.552562 26.824019 17.072266 26.199219 16.592866 25.575584 C 16.383528 25.251054 16.208984 25.021484 15.897202 24.609805 C 14 21.970851 14 19.59375 14 19.59375 C 14 17.077989 15.168497 16.091436 15.800781 15.410156 C 16.132721 15.052495 16.495617 15 16.642578 15 z"/></svg>
                    <a href="https://api.whatsapp.com/send?phone=905469999333" class="cf-phone-link" rel="nofollow noopener noreferrer" target="_blank">+90 546 999 93 33</a>
                    <span class="cf-phone-tag">{{ $t('phone_only_whatsapp') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-8 d-flex flex-wrap" style="max-width: 370px; margin-top: 20px;">
              <div
                class="me-3 flex h-60 w-60 max-w-60 pe-2 justify-content-center overflow-hidden rounded text-primary"
              >
                <svg
                  width="30"
                  height="50"
                  viewBox="0 0 28 19"
                  class="fill-current"
                >
                  <path
                    d="M25.3636 0H2.63636C1.18182 0 0 1.16785 0 2.6052V16.3948C0 17.8322 1.18182 19 2.63636 19H25.3636C26.8182 19 28 17.8322 28 16.3948V2.6052C28 1.16785 26.8182 0 25.3636 0ZM25.3636 1.5721C25.5909 1.5721 25.7727 1.61702 25.9545 1.75177L14.6364 8.53428C14.2273 8.75886 13.7727 8.75886 13.3636 8.53428L2.04545 1.75177C2.22727 1.66194 2.40909 1.5721 2.63636 1.5721H25.3636ZM25.3636 17.383H2.63636C2.09091 17.383 1.59091 16.9338 1.59091 16.3499V3.32388L12.5 9.8818C12.9545 10.1513 13.4545 10.2861 13.9545 10.2861C14.4545 10.2861 14.9545 10.1513 15.4091 9.8818L26.3182 3.32388V16.3499C26.4091 16.9338 25.9091 17.383 25.3636 17.383Z"
                  />
                </svg>
              </div>
              <div class="flex-grow-1">
                <h3 class="mb-0 contact-title-2 bold">
                  {{ $t("Email") }}
                </h3>
                <p class="contact-desc bold">
                  <a
                    href="mailto:onlinecc@salamisbayconti.com"
                    class="text-decoration-none text-black"
                    >onlinecc@salamisbayconti.com
                  </a>
                  <br />
                  <a
                    href="mailto:reservation@salamisbayconti.com"
                    class="text-decoration-none text-black"
                    >reservation@salamisbayconti.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-6 aos-init"
          data-aos="fade-left"
          data-aos-once="false"
          data-aos-duration="1500"
        >
          <div class="p-4 bg-white rounded shadow-lg">
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <label for="name" class="form-label">{{ $t("name") }}</label>
                <input
                  type="text"
                  v-model="form.name"
                  id="name"
                  class="form-control"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="email" class="form-label">{{ $t("Email") }}</label>
                <input
                  type="email"
                  v-model="form.email"
                  id="email"
                  class="form-control"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="contact" class="form-label">{{
                  $t("contact_no")
                }}</label>
                <input
                  type="text"
                  v-model="form.phone_number"
                  id="phone_number"
                  class="form-control"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="message" class="form-label">{{
                  $t("message")
                }}</label>
                <textarea
                  v-model="form.message"
                  type="text"
                  id="message"
                  class="form-control"
                  rows="4"
                  required
                ></textarea>
              </div>
              <button :disabled="isSubmitting || submissionDisabled" type="submit" class="detail-btn w-100 py-3">
                {{ $t("send") }}
              </button>
            </form>
            <div v-if="submissionMessage" class="success-message">
              {{ submissionMessage }}
            </div>
            <div v-if="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { VueReCaptcha, useReCaptcha } from "vue-recaptcha-v3";
import { useNuxtApp } from '#app';

export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone_number: "",
        message: "",
      },
      submissionMessage: null,
      errorMessage: null,
      isSubmitting: false,
      // Kill switch for spam waves: set to true to disable the button and
      // stop submissions without touching the rest of the form.
      submissionDisabled: false,
    };
  },
  setup() {
    if (process.client) {
      const nuxtApp = useNuxtApp();

      // Install VueReCaptcha only if not already installed
      if (!nuxtApp.vueApp._context.provides['$recaptcha']) {
        nuxtApp.vueApp.use(VueReCaptcha, {
          siteKey: '6LdG4wEuAAAAANgzhUk1FjsnfXkmLtxG5UYnDvTK',
          loaderOptions: {
            useRecaptchaNet: true,
            autoHideBadge: true
          }
        });
      }

      const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

      const recaptcha = async () => {
        await recaptchaLoaded();
        return await executeRecaptcha("contact");
      };
      return {
        recaptcha,
      };
    }
    return {
      recaptcha: async () => null,
    };
  },

  methods: {
    async submitForm() {
      if (this.submissionDisabled) return;
      this.isSubmitting = true; // Disable the button when submitting

      // Execute reCAPTCHA and get the token
      const token = await this.recaptcha();

      // Check if the token is valid
      if (!token) {
        this.errorMessage = "Invalid reCAPTCHA. Please try again.";
        this.submissionMessage = null; 
        alert(this.errorMessage);
        this.isSubmitting = false; 
        return;
      }

      try {
        // The token goes with the form and the backend verifies it there
        // (reCAPTCHA tokens are single-use, so it can't be checked twice).
        const formData = new FormData();
        formData.append("name", this.form.name);
        formData.append("email", this.form.email);
        formData.append("contact", this.form.phone_number);
        formData.append("message", this.form.message);
        formData.append("recaptcha_token", token);

        const formSubmitResponse = await fetch(
          "https://api2.salamisbayconti.com/api/forms/contact",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
            },
            body: formData,
          }
        );

        // Check if the form submission response is okay (status 200-299)
        if (formSubmitResponse.ok) {
          const result = await formSubmitResponse.json();
          this.submissionMessage = "Contact form submitted successfully!";
          this.errorMessage = null; // Clear any previous error messages
          alert(this.submissionMessage); // Show success alert
          this.resetForm();
        } else {
          // Handle errors from the form submission server (including a failed reCAPTCHA)
          const error = await formSubmitResponse.json();
          this.errorMessage = error.message || "Error submitting form.";
          alert(this.errorMessage);
          this.submissionMessage = null; // Clear any previous success messages
        }
      } catch (error) {
        console.error("Submission error:", error);
        this.errorMessage = "An error occurred while submitting the form.";
        this.submissionMessage = null; // Clear any previous success messages
        alert(this.errorMessage); // Show error alert
      } finally {
        this.isSubmitting = true; // Keep the button disabled for 30 seconds
        setTimeout(() => {
          this.isSubmitting = false; // Re-enable the button after 30 seconds
        }, 30000);
      }
    },
    resetForm() {
      this.form.name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.message = "";
    },
  },

};
</script>


<style scoped>
.detail-btn:disabled,
.detail-btn:disabled:hover {
  opacity: 0.5;
  cursor: not-allowed;
  scale: 1;
}
.contact-font {
  font-family: "Cormorant Garamond", Georgia, serif;
  color: black;
}
.contact-sub-title {
  color: #9b9b9b;
  font-size: 1rem;
}
.contact-title {
  font-family: "Cormorant Garamond", Georgia, serif;
  font-size: 3rem;
  color: black;
}
.contact-title-2 {
  font-family: "Cormorant Garamond", Georgia, serif;
  font-size: 1.5rem;
  color: black;
}
.contact-desc {
  font-family: "Cormorant Garamond", Georgia, serif;
  font-size: 1.2rem;
  color: black;
}
.cf-phone-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}
.cf-phone-row {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}
.cf-phone-row svg {
  flex-shrink: 0;
  color: #042333;
}
.cf-phone-row:last-child svg {
  color: #25D366;
}
.cf-phone-link {
  font-family: "Cormorant Garamond", Georgia, serif;
  font-size: 1.15rem;
  font-weight: 800;
  color: #000;
  text-decoration: none;
}
.cf-phone-link:hover { color: #042333; }
.cf-phone-tag {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #555;
}
.cf-phone-tag::before { content: '('; }
.cf-phone-tag::after  { content: ')'; }

@media (max-width: 768px) {
  .contact-title {
    font-family: "Cormorant Garamond", Georgia, serif;
    font-size: 2rem;
    color: black;
  }
  .contact-title-2 {
    font-family: "Cormorant Garamond", Georgia, serif;
    font-size: 1.3rem;
    color: black;
  }
  .contact-desc {
    font-family: "Cormorant Garamond", Georgia, serif;
    font-size: 1.1rem;
    color: black;
  }
}
</style>